import Service, { type Registry as Services, service } from '@ember/service';

export default class PricingAssistantPmsAccessService extends Service {
  @service declare access: Services['access'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasEditableHierarchy() {
    return !this.hasUneditableHierarchy;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasUneditableHierarchy() {
    return this.access.hasFeature('pricing_assistant.pms.uneditable_hierarchy');
  }
}

declare module '@ember/service' {
  interface Registry {
    'pricing-assistant-pms-access': PricingAssistantPmsAccessService;
  }
}
